var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form-control', {
    attrs: {
      "field": _vm.field
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('v-file-uploader', {
          attrs: {
            "loader": _vm.loader,
            "name": _vm.field,
            "disabled": _vm.disabled,
            "files": _vm.files,
            "caption": _vm.caption,
            "label": _vm.label,
            "error": api.getTouched() ? api.getError() : undefined
          },
          on: {
            "remove": function($event) {
              _vm.$emit('remove', $event)
            },
            "input": function($event) {
              _vm.handleChange($event, api)
            }
          }
        })]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49c6e6db","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/appComponents/components/Form/FormFile.vue
// module id = 700
// module chunks = 0